import { Injectable } from '@angular/core';
import { SettingsService } from '../../services/settings/settings.service';
import { Observable } from 'rxjs';
import { CommonHelperService } from '../../utilities/common-helper/common-helper.service';
import { DailySchedule } from '../../models/settings/daily-schedule.model';
import { Mapper } from '@dynamic-mapper/angular';
import { DailyScheduleDTO } from 'src/app/domain/settings/daily-schedule.dto';
import { DailyScheduleData } from '../../mappings/settings/daily-schedule.mapping';
import { ScheduleCreate } from '../../models/settings/daily-schedule-create';
import { DailyScheduleTime } from '../../models/settings/daily-schedule-time.model';
@Injectable({
  providedIn: 'root'
})
export class SettingsBusinessService {

  constructor(private settingsService: SettingsService, private commonHelper: CommonHelperService, private readonly mapper: Mapper) {}

  createOpenHours(data: object): Observable<ScheduleCreate> {
    return new Observable((observe) => {
      this.settingsService.createOpenHours(data).subscribe({
        next: (response) => {
          try {
            observe.next(response);
          }
          catch(e) {
            observe.error(e);
          }
        },
        error: (error) => {
          observe.error(error);
        }
      })
    })
  }

  updateOpenHours(data: object): Observable<ScheduleCreate> {
    return new Observable((observe) => {
      this.settingsService.updateOpenHours(data).subscribe({
        next: (response) => {
          try {
            observe.next(response)
          }
          catch(e) {
            observe.error(e);
          }
        },
        error: (error) => {
          observe.error(error);
        }
      })
    })
  }

  getOpenHoursById(data:DailySchedule): Observable<DailyScheduleDTO[]> {
    return new Observable((observe) => {
      this.settingsService.getOpenHoursById(data).subscribe({
        next: (response: DailySchedule[]) => {
          try {
            let result: DailyScheduleDTO[] = [];
            result = this.commonHelper.genericArrayMapper(response, DailyScheduleData.DtoToDomain)
            observe.next(result)
          }
          catch(e) {
            observe.error(e);
          }
        },
        error: (error) => {
          observe.error(error);
        }
      })
    })
  }

  cancelOpenHours(data: DailyScheduleTime): Observable<DailyScheduleTime> {
    return new Observable((observe) => {
      this.settingsService.cancelOpenHours(data).subscribe({
        next: (response) => {
          try {
            observe.next(response)
          }
          catch(e) {
            observe.error(e);
          }
        },
        error: (error) => {
          observe.error(error);
        }
      })
    })
  }

  downloadQrPoster(data: object):Observable<any>{
    return new Observable((observer) => {
      this.settingsService.downloadQrPoster(data).subscribe({
        next: (response) => {
          try {
            observer.next(response)
          }
          catch (e) {
            observer.error(e);
          }
        },
        error: (error) => {
          observer.error(error);
        }
      })
    })
  }
}
